
export module MathFunc{
    //@param:exp ranges from 1 to infinity. 1 = linear, 2 is more like quadratic, infinity = step
    export function easeIneaseOut(val : number, exp : number){
        let a = Math.pow(val, exp);
        return a / (a + Math.pow(1-val, exp));
    }

    export function interpolate(a : number, b : number, interpolant : number){
        return a + (b-a)*interpolant;
    }

    export function angleToRadian(angle: number): number{
        return (Math.PI * angle) / 180;
    }
}